const capitalize = (data) => {
    return (data.charAt(0).toUpperCase() + data.slice(1))

}

export default capitalize